<template>
  <div class="footer flex flex--horizontal flex--justify-space-between">
    <div><a :href="documentManagerURL">zpátky do Document Manageru</a></div>
    <div>&copy; <a href="https://cloudaper.com">Cloudaper</a></div>
  </div>
</template>

<script>
export default {
  name: 'FooterComponent',
  data() {
    return {
      documentManagerURL: process.env.VUE_APP_DOCUMENT_MANAGER_URL,
    };
  },
};
</script>

<style scoped>
.footer {
  padding: var(--unit-extra-large);
}
</style>
